import {FC} from 'react';
import BaseNavigationTabs from 'components/Navigation/BaseNavigationTabs';
import BaseNavigationTabsButton from 'components/Navigation/BaseNavigationTabs/BaseNavigationTabsButton';
import {NavigationTabsPropsHelper} from 'components/Navigation/BaseNavigationTabs/types';
import {c} from 'ttag';

type NavigationTabsClientProps = NavigationTabsPropsHelper<{
    mid: string;
}>;

const NavigationTabsClient: FC<NavigationTabsClientProps> = ({
    className,
    mid,
    selection,
}) => (
    <BaseNavigationTabs className={className} selection={selection}>
        <BaseNavigationTabsButton
            href={window.Urls.client_summary_view(mid)}
            label={c('component').t`Summary`}
            name="summary"
        />
        <BaseNavigationTabsButton
            href={window.Urls.client_contact_view(mid)}
            label={c('component').t`Contact`}
            name="contact"
        />
        <BaseNavigationTabsButton
            href={window.Urls.client_contact_history_view(mid)}
            label={c('component').t`Client History`}
            name="clientHistory"
        />
        <BaseNavigationTabsButton
            href={window.Urls.client_securesend_view(mid)}
            label={c('component').t`Sending Settings`}
            name="sendingSettings"
        />
        <BaseNavigationTabsButton
            href={window.Urls.client_document_send_view(mid)}
            label={c('component').t`Documents`}
            name="documents"
        />
        <BaseNavigationTabsButton
            href={window.Urls.client_notes(mid)}
            label={c('component').t`Notes`}
            name="notes"
        />
    </BaseNavigationTabs>
);

export default NavigationTabsClient;
